import { jsxs as r, jsx as i } from "react/jsx-runtime";
import { Dialog as d } from "./index29.mjs";
import { messages as e } from "./messages.mjs";
import { Button as l } from "./index26.mjs";
import { DialogTitle as g } from "./DialogTitle.mjs";
import { DialogContent as p } from "./DialogContent.mjs";
import { DialogActions as u } from "./DialogActions.mjs";
const B = (n) => {
  const {
    locale: o,
    onAgreeClick: a,
    onLogOutClick: c,
    isAgreeButtonLoading: s,
    isPreview: t,
    testId: m
  } = n;
  return /* @__PURE__ */ r(
    d,
    {
      open: !0,
      fullWidth: !0,
      maxWidth: "sm",
      handleClose: () => {
      },
      hasCloseIcon: !1,
      "data-testid": m,
      disablePortal: t,
      disableScrollLock: t,
      disableEnforceFocus: t,
      children: [
        /* @__PURE__ */ i(g, { children: e.title[o] }),
        /* @__PURE__ */ i(p, { children: e.description[o] }),
        /* @__PURE__ */ r(u, { children: [
          /* @__PURE__ */ i(
            l,
            {
              variant: "contained",
              size: "medium",
              color: "primary",
              onClick: c,
              children: e.logOutButton[o]
            }
          ),
          /* @__PURE__ */ i(
            l,
            {
              variant: "contained",
              size: "medium",
              color: "primary",
              onClick: a,
              isLoading: s,
              children: e.agreeButton[o]
            }
          )
        ] })
      ]
    }
  );
};
export {
  B as AcceptPoliciesDialog
};
//# sourceMappingURL=index240.mjs.map
